import React, { useEffect, useState } from 'react';
import { Prompt, useLocation } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { Typography } from 'wtb-components';
import { useLocaleContext } from 'context';
import { Summary } from 'components';
import { ANALYTICS_EVENTS } from 'constants.js';
import { useSendAnalyticsEvent } from 'hooks';
import { ReactComponent as SuccessImage } from 'assets/images/success.svg';
import styles from '../Finish.module.css';

const Success = () => {

  const location = useLocation();

  const { translate } = useLocaleContext();

  const [ eventSent, setEventSent ] = useState(false);

  const sendAnalyticsEvent = useSendAnalyticsEvent();

  const promptMessage = (_location, action) => {
    if (action === 'POP' && location.pathname.includes('/success')) {
      return translate('finish.leaveAlert');
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (!sendAnalyticsEvent || eventSent) return;

    setEventSent(true);

    sendAnalyticsEvent(ANALYTICS_EVENTS.SUCCESS);
  }, [ sendAnalyticsEvent, eventSent ]);

  return (
    <>
      <SuccessImage className={styles.animation} data-testid="image-success" />

      <Typography variant="h6" align="center" id="finish-title" className={styles.title}>
        {translate('finish.success.title')}
      </Typography>

      <Typography variant="body1" align="center" color="textSecondary" id="finish-subtitle">
        <Trans
          i18nKey="finish.success.subtitle"
          components={[ <Typography variant="body1" align="center" fontWeight="bold" /> ]}
        />
      </Typography>

      <Summary />

      <Prompt message={promptMessage} />
    </>
  );
};

export default Success;
